<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
    style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='住培操作限制管理' url='/achievement/set/delivermoneymonth'></SearchTitle>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form"
        ref="form">
        <div class="m-portlet__body">
          <!--begin: Form Body -->
          <div class="form-group m-form__group">
            <el-form-item label="入科限制">
              <el-switch v-model="form.EntryLimit" active-text="限制" inactive-text="不限制" @change="EntryLimitChange()">
              </el-switch>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ConfigLimit',
    data() {
      return {
        form: {
          token: '',
          username: '',
          rolelevel: '',
          EntryLimit: true
        },
        fullscreenLoading: false,
      }
    },
    methods: {
      EntryLimitChange: function() {
        const loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APIDictItem/EntryLimitChange', this.form)
          .then(res => {
            if (res.data.Code === 0) {
              that.$message({
                message: '变更成功',
                type: 'success'
              })
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Data,
                type: 'error'
              })
            }
            
            loading.close()
          })
          .catch(err => {
            console.log(err)
            that.$message({
              message: '变更失败',
              type: 'error'
            })
            
            loading.close()
          })
      },
      LoadEntryLimit: function() {
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APIDictItem/LoadEntryLimit', this.form)
          .then(res => {
            if (res.data.Code === 0) {
              var info = res.data.Data
              if (info.ConfigValue == '0') {
                that.form.EntryLimit = false
              }
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Data,
                type: 'error'
              })
            }
          })
          .catch(err => {
            console.log(err)
            that.$message({
              message: '变更失败',
              type: 'error'
            })
          })
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.username = sessionStorage.getItem('username')
      this.form.rolelevel = sessionStorage.getItem('rolelevel')

      this.LoadEntryLimit()
    }
  }
</script>

<style>
</style>
